module.exports = __webpack_public_path__ + "media/images/design/common/images/btn_entry-ae153c65873d20af79fbe7a5c7f881c2.jpg";